var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(
      _vm.$route.name === 'preference-table' ||
      _vm.$route.name === 'my-dashboard-details' ||
      _vm.$route.name === 'data-table' ||
      _vm.$route.name === 'embed-dashboard' ||
      _vm.$route.name === 'sections'
    )?_c('div',[_c('stepper')],1):_vm._e(),(_vm.$store.state.CUSTOM_DASHBOARD_STORE.editMode)?_c('div',{staticClass:"text-center"},[_c('span',{staticClass:"w-100 bg-warning text-white d-block small"},[_vm._v("Edit Mode")])]):_vm._e(),_c('router-view',{staticClass:"mt-5"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }